import { render, staticRenderFns } from "./index-yn.vue?vue&type=template&id=62c6f57b&"
import script from "./index-yn.vue?vue&type=script&lang=js&"
export * from "./index-yn.vue?vue&type=script&lang=js&"
import style0 from "./index-yn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports